import { Link } from 'react-router-dom';


import styles from './Navbar.module.css';


const Navbar = ({active}) => {


  return (
    <nav className={styles.navbar}>
      <h1>
        <Link to='/'>Serhii serbin</Link>
      </h1>
      <div className={styles.links}>
        <Link to="/about">about</Link>
      </div>
    </nav>
  );
}

export default Navbar;